'use strict';

function CompanySkillsService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/skills/:skillId', {}, {
    'update':  {
      method: 'PUT'
    },
    'delete': {
      method: 'DELETE'
    }
  });
}

angular.module('dokiv')
  .factory('CompanySkillsService', ['$resource', 'config', CompanySkillsService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/skills/CompanySkillsService.js
// module id = 66
// module chunks = 0